import React from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  return <section id="contact" className="py-32 md:py-48 bg-background relative border-b border-border" data-id="element-31">
      <div className="container mx-auto px-6 md:px-12" data-id="element-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24" data-id="element-33">
          {/* Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} data-id="element-34">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-serif text-primary mb-12" data-id="element-35">
              Давайте <br data-id="element-36" />
              <span className="italic text-secondary" data-id="element-37">створювати</span>
            </h2>
            <p className="text-secondary font-sans text-sm font-light mb-16 max-w-md leading-relaxed" data-id="element-38">
              Готові обговорити вашу наступну подію? Залиште свої контакти, і
              наш менеджер зв'яжеться з вами найближчим часом.
            </p>

            <div className="space-y-12 font-sans" data-id="element-39">
              <div data-id="element-40">
                <h4 className="text-secondary uppercase tracking-super-wide text-[10px] mb-4" data-id="element-41">
                  Телефон
                </h4>
                <a href="tel:+380441234567" className="text-xl text-primary hover:text-secondary transition-colors font-light" data-id="element-42">
                  +380 44 123 45 67
                </a>
              </div>
              <div data-id="element-43">
                <h4 className="text-secondary uppercase tracking-super-wide text-[10px] mb-4" data-id="element-44">
                  Email
                </h4>
                <a href="mailto:hello@aura-events.com" className="text-xl text-primary hover:text-secondary transition-colors font-light" data-id="element-45">
                  hello@aura-events.com
                </a>
              </div>
              <div data-id="element-46">
                <h4 className="text-secondary uppercase tracking-super-wide text-[10px] mb-4" data-id="element-47">
                  Офіс
                </h4>
                <p className="text-xl text-primary font-light" data-id="element-48">
                  вул. Хрещатик, 15
                  <br data-id="element-49" />
                  Київ, Україна
                </p>
              </div>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="lg:pl-12" data-id="element-50">
            <form className="space-y-16" onSubmit={e => e.preventDefault()} data-id="element-51">
              <div className="relative group" data-id="element-52">
                <input type="text" id="name" className="w-full bg-transparent border-b border-border py-4 text-primary font-sans font-light focus:outline-none focus:border-primary transition-colors peer placeholder-transparent" placeholder="Ваше ім'я" required data-id="element-53" />
                <label htmlFor="name" className="absolute left-0 top-4 text-secondary text-[11px] uppercase tracking-widest transition-all peer-focus:-top-4 peer-focus:text-[9px] peer-focus:text-primary peer-valid:-top-4 peer-valid:text-[9px]" data-id="element-54">
                  Ваше ім'я
                </label>
              </div>

              <div className="relative group" data-id="element-55">
                <input type="tel" id="phone" className="w-full bg-transparent border-b border-border py-4 text-primary font-sans font-light focus:outline-none focus:border-primary transition-colors peer placeholder-transparent" placeholder="Телефон" required data-id="element-56" />
                <label htmlFor="phone" className="absolute left-0 top-4 text-secondary text-[11px] uppercase tracking-widest transition-all peer-focus:-top-4 peer-focus:text-[9px] peer-focus:text-primary peer-valid:-top-4 peer-valid:text-[9px]" data-id="element-57">
                  Телефон
                </label>
              </div>

              <div className="relative group" data-id="element-58">
                <select id="type" className="w-full bg-transparent border-b border-border py-4 text-primary font-sans font-light focus:outline-none focus:border-primary transition-colors appearance-none cursor-none" required defaultValue="" data-id="element-59">
                  <option value="" disabled className="bg-background text-secondary" data-id="element-60">
                    Тип події
                  </option>
                  <option value="corporate" className="bg-background" data-id="element-61">
                    Корпоративна подія
                  </option>
                  <option value="private" className="bg-background" data-id="element-62">
                    Приватна вечірка
                  </option>
                  <option value="wedding" className="bg-background" data-id="element-63">
                    Весілля
                  </option>
                  <option value="other" className="bg-background" data-id="element-64">
                    Інше
                  </option>
                </select>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-secondary text-xs" data-id="element-65">
                  ▼
                </div>
              </div>

              <button type="submit" className="w-full border border-border text-primary py-6 font-sans uppercase tracking-super-wide text-[11px] hover:bg-primary hover:text-background transition-all duration-700 mt-8" data-id="element-66">
                Надіслати запит
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}